import { SEGMENT_TAGS } from '@/constants';

export const splitTagsAndSegments = (tags: string[]) => {
    const cleanTags: string[] = [];
    const cleanSegments: string[] = [];

    tags?.forEach((t: string) => {
        if (SEGMENT_TAGS.includes(t)) {
            cleanSegments.push(t);
            return;
        }
        cleanTags.push(t);
    });
    return [cleanTags, cleanSegments];
};
